import lodash from "lodash"
import moment from "moment"

import { createAtom, createAtomFamily } from "utils/recoil"

const prefix = "containers/Templates/TemplateEditor"

export const stateState = createAtom({
  prefix,
  key: "state"
})

export const isLoadingState = createAtom({
  prefix,
  key: "isLoading"
})
